// Summary: This file contains string constants used by the react app.
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";

TimeAgo.setDefaultLocale(en.locale);
TimeAgo.addLocale(en);

export const SLASH = "/" as string;
export const COLON = ":" as string;

export const ADMIN = "admin" as string;
// export const AGREEMENT_METRICS = "agreementMetrics" as string;
export const SUBSCRIBE = "subscribe" as string;
export const CLAIM = "claim" as string;
export const CLAIMS = "claims" as string;
export const CONTEST_SELECTIONS = "contest-selections" as string;
export const COMPOSE = "compose" as string;
export const ERROR = "error" as string;
// export const EXPANSIONS = "expansions" as string;
export const HOME = "home" as string;
export const ID = "id" as string;
export const ME = "me" as string;
export const RECENT_CLAIMS = "recent-claims" as string;
export const HOW_IT_WORKS = "how-it-works" as string;
export const SIGN_IN = "sign_in" as string;
export const TEXT = "text" as string;
export const USERS = "users" as string;
// export const AUTHOR_ID = "authorId" as string;
export const COLON_ID: string = COLON + ID as string;
const OOPS = "Sentibot Claim" as string;
export const OOPS_HEADER = OOPS as string;
export const OOPS_MESSAGE_GENERIC: string =
  "Sentiment is having a problem -- try your request again in a few moments." as string;
export const NOT_SUBSCRIBED: string = "NOT_SUBSCRIBED" as string;
